module.exports = __webpack_public_path__ + "media/images/food-long-8877ea07c26b1d85a8287e426912433a.jpg";